import permissions from '@/constants/permissions'

const ChildrenList = () => import('@/views/dashboard/ChildrenList.vue')

export default [
  {
    path: '/lista-dzieci',
    name: 'ChildrenList',
    component: ChildrenList,
    meta: {
      requireAuth: true,
      permission: permissions.childEditionListView
    }
  },
  {
    path: '/lista-dzieci-wolontariusz',
    name: 'MyChildrenList',
    component: ChildrenList,
    meta: {
      requireAuth: true,
      permission: permissions.assignedChildEditionListView
    }
  },
  {
    path: '/lista-dzieci-koordynator-szkolny',
    name: 'CoordinatorsChildrenList',
    component: ChildrenList,
    meta: {
      requireAuth: true,
      permission: permissions.coordinatorChildEditionListView
    }
  }
]
